export * from './lib/my-doctor.module';

export * from './lib/components/medmij-auth-back/medmij-auth-back.component';
